import { render, staticRenderFns } from "./orderSource.vue?vue&type=template&id=8abd774c&scoped=true"
import script from "./orderSource.vue?vue&type=script&lang=js"
export * from "./orderSource.vue?vue&type=script&lang=js"
import style0 from "./orderSource.vue?vue&type=style&index=0&id=8abd774c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8abd774c",
  null
  
)

export default component.exports